module.exports = __webpack_public_path__ + "img/success.9544303.png";